import React from 'react';
import styles from './../styles/components/droplogout.module.scss';
import { MdExitToApp } from "react-icons/md";


const DropLogOut = ({ visible, signOut }) => {
  return (
    <>
      {visible && <section className={styles.__logout}>
        <button className={styles.__logoutButton} onClick={signOut}><MdExitToApp size={20} />Log Out</button>
      </section>}
    </>
  )
}

export default DropLogOut;
